/* eslint-disable no-unused-vars */
import apiService from '@/utils/api-client'
import config from '@/utils/appConfig'
import {
  mapCategoriesFromApi,
  mapIntegrationItem,
} from '@/pages/integrations/utils/integrations-api-mapper'
import {
  getCatalogErrorMessage,
  integrationsApiBaseUrl,
} from '@/pages/integrations/utils/integrations-api'
import { integrationsCatalogMock } from '@/pages/integrations/utils/integrations-catalog-mock'

export default {
  async fetchIntegrationsCatalog({ commit }) {
    commit('SET_CATALOG_LOADING', true)
    commit('SET_CATALOG_ERROR', null)
    try {
      const response = config.VUE_APP_FEATURE_INTEGRATIONS_CATALOG_MOCK
        ? integrationsCatalogMock
        : await apiService.get('/integrations', {
            baseURL: integrationsApiBaseUrl,
          })

      if (!response?.success) {
        throw new Error('Failed to load integrations catalog')
      }

      const categories = mapCategoriesFromApi(response.data?.categories || [])
      commit('SET_CATEGORIES', categories)
    } catch (error) {
      commit('SET_CATALOG_ERROR', getCatalogErrorMessage(error))
      commit('SET_CATEGORIES', [])
      throw error
    } finally {
      commit('SET_CATALOG_LOADING', false)
    }
  },
  async fetchIntegrationBySlug({ commit }, { slug }) {
    try {
      const response = await apiService.get(`/integrations/${slug}`, {
        baseURL: integrationsApiBaseUrl,
      })

      if (!response?.success || !response?.data) {
        commit('SET_INTEGRATION_BY_SLUG', { slug, integration: null })
        return null
      }

      const integration = mapIntegrationItem(response.data)
      commit('SET_INTEGRATION_BY_SLUG', { slug, integration })
      return integration
    } catch (error) {
      if (error?.response?.status === 404) {
        commit('SET_INTEGRATION_BY_SLUG', { slug, integration: null })
        return null
      }
      throw error
    }
  },
  getAuthUrl({ commit }, { connectType }) {
    try {
      return apiService.get(`${connectType}/authUrl`, {
        baseURL: config.VUE_APP_API_3D_INTEGRATIONS,
      })
    } catch (error) {
      console.error(error)
    }
  },
  getNotificationsConnect({ commit }, { connectType }) {
    try {
      return apiService.get(`notifications/connect/${connectType}`, {
        baseURL: config.VUE_APP_API_3D_INTEGRATIONS,
      })
    } catch (error) {
      console.error(error)
    }
  },
  deleteNotificationsConnect({ commit }, { connectType }) {
    try {
      return apiService.delete(`notifications/disconnect/${connectType}`, {
        baseURL: config.VUE_APP_API_3D_INTEGRATIONS,
      })
    } catch (error) {
      console.error(error)
    }
  },
  createConnect({ commit }, { connectType, connectionData = {} }) {
    try {
      return apiService.post(
        `${connectType}/connect`,
        { ...connectionData },
        {
          baseURL: config.VUE_APP_API_3D_INTEGRATIONS,
        },
      )
    } catch (error) {
      console.error(error)
    }
  },
  deleteConnect({ commit }, { connectType }) {
    try {
      return apiService.post(
        `${connectType}/disconnect`,
        {},
        {
          baseURL: config.VUE_APP_API_3D_INTEGRATIONS,
        },
      )
    } catch (error) {
      console.error(error)
    }
  },
  createTickets({ commit }, { connectType, paramsData = {} }) {
    try {
      return apiService.post(
        `${connectType}/tickets`,
        paramsData,
        { baseURL: config.VUE_APP_API_3D_INTEGRATIONS }
      )
    } catch (error) {
      console.error(error)
    }
  },
  getTickets({ commit }, { connectType, paramsData = {} }) {
    try {
      return apiService.post(
        `${connectType}/tickets/find`,
        { ...paramsData },
        {
          baseURL: config.VUE_APP_API_3D_INTEGRATIONS,
        },
      )
    } catch (error) {
      console.error(error)
    }
  },
  getResources({ commit }, { connectType }) {
    try {
      return apiService.get(`${connectType}/resources`, {
        baseURL: config.VUE_APP_API_3D_INTEGRATIONS,
      })
    } catch (error) {
      console.error(error)
    }
  },
  getProjects({ commit }, { connectType, resourceId }) {
    try {
      return apiService.get(`${connectType}/resources/${resourceId}/projects`, {
        baseURL: config.VUE_APP_API_3D_INTEGRATIONS,
      })
    } catch (error) {
      console.error(error)
    }
  },
  getIssueTypes({ commit }, { connectType, resourceId, projectId }) {
    try {
      return apiService.get(
        `${connectType}/resources/${resourceId}/projects/${projectId}/issueTypes`,
        {
          baseURL: config.VUE_APP_API_3D_INTEGRATIONS,
        },
      )
    } catch (error) {
      console.error(error)
    }
  },
}
